import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SOCIAL_STARTER_TALKING_POINTS_PROMPT = defineFcm('social_starter_talking_points_prompt')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				promptId: { type: 'string' },
			},
		}),
	)
	.withDefault({
		enabled: false,
		promptId: '',
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: ['corgi-middle-end'],
		context: 'Post-Start A Petition Social Starter Onboarding',
		description:
			'LangSmith Hub prompt id used to generate the social-starter share-step talking-point examples (stakes / personal reason) from petition content.',
		template: {
			enabled: false,
			promptId: '',
		},
	});
